define('waproductbox', ['jquery'], function ($) {

  var waproductbox = {

    sizeArray: [],
    categoryStopper: $('.category-tile-banner'),
    productList: $('.product__list'),

    js_productbox: function js_productbox() {
      var _this = this;

      this.showCategoryPeerius();
      this.showServiceBanner();
      this.showCategoryStopper();

      if (!!window.isTouchDevice) return;

      this.switchGridView();

      $('.js_productbox:not(.mo_bigban__ban):not([data-motivearticle])').mouseenter(function (e) {
        var self = $(e.currentTarget);
        _this.showSecondProductImage(self);
      });
    },
    showSecondProductImage: function showSecondProductImage(self) {
      if (!window.isTouchDevice) {
        var secondImage = self.find('.product__image--second');
        secondImage.one("load", function () {
          secondImage.addClass('js_isload');
        }).attr("src", secondImage.data('src'));
      }
    },
    switchGridView: function switchGridView() {
      var gridViewBtns = $('#js_masonry, #js_flexgrid');
      var productList = $('.product__list');
      var masonry = new RegExp("masonry");

      if (gridViewBtns.length > 0) {
        gridViewBtns.on('click', function (e) {
          var self = $(e.currentTarget);
          var gridViewBtnId = self.attr('id');

          if (masonry.test(gridViewBtnId)) {
            productList.removeClass('small-block-grid-2').removeClass('medium-block-grid-3').removeClass('large-block-grid-3').addClass('masonry');
          } else {
            productList.removeClass('masonry').addClass('small-block-grid-2').addClass('medium-block-grid-3').addClass('large-block-grid-3');
          }
        });
      }
    },
    showServiceBanner: function showServiceBanner() {
      try {
        var serviceBanner = $('#service-banner');
        if (serviceBanner.length) {
          var newElement = $($.parseHTML('<li class="product__item / js_productbox full__width__item"></li>'));
          var position = 13;
          var colSize = 0;
          var top = $('.product__item').position().top;

          $('.product__item').each(function () {
            if ($(this).position().top == top) {
              colSize++;
            } else {
              return false;
            }
          });

          var targetProd = $('.product__item').eq(colSize * position - 1);
          if (targetProd.length) {
            newElement.insertAfter(targetProd);
            newElement.append(serviceBanner);
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    showCategoryPeerius: function showCategoryPeerius() {
      var categoryPeeriusWidget = $('#peerius-smartrecs-categorywidget2');
      if (categoryPeeriusWidget.length) {
        var newElement = $($.parseHTML('<li class="product__item / js_productbox full__width__item peerius-item"></li>'));
        var position = 2;
        var colSize = 0;
        var top = $('.product__item').position().top;

        $('.product__item').each(function () {
          if ($(this).position().top == top) {
            colSize++;
          } else {
            return false;
          }
        });

        var targetProd = $('.product__item').eq(colSize * position - 1);
        if (targetProd.length) {
          newElement.insertAfter(targetProd);
          newElement.append(categoryPeeriusWidget);
        }
      }
    },
    showCategoryStopper: function showCategoryStopper() {
      var _this2 = this;

      var productItems = window.wabreakpoint === 'large' ? 3 : 2;
      $.each(this.categoryStopper, function (index, stopper) {
        var self = $(stopper);
        var dataPosition = self.data('position');
        var calculatedRow = dataPosition * productItems + index + $('.product__item.peerius-item').length;
        self.insertBefore(_this2.productList.find('li').eq(calculatedRow)).show();
      });
    }
  };

  return waproductbox;
});

